import { NgIf, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';
import { CommonService } from '../../../../services/common.service';
import { NotificationService } from '../../../../services/notification.service';

@Component({
    selector: 'app-manage-leaks',
    imports: [NextPage, TableModule, NgIf, NgClass, ButtonModule, FormsModule],
    templateUrl: './manage-leaks.component.html',
    styleUrl: './manage-leaks.component.scss'
})
export class ManageLeaksComponent {
  leakData : any = [];
  exportData : any = [];
  newLeakName = '';
  SaveSuccess = false;
  errorData = false;
  isLoading: boolean = false;
  constructor(private adminService:AdminService,private commonService:CommonService,private messageService:NotificationService){
    this.isLoading = true;
    this.setLeakData();
  }

  setLeakData(){
    this.isLoading = true;
    this.adminService.getAllUserInteractions('ManageLeaks').subscribe((response: any) => {
        this.leakData = response;
        this.setExportData(response);
        this.processData();
    });
  };

  setExportData(data: any){
    this.exportData = data.map((item: any) => ({
      RecID: item.RecID,
      FacilityID: item.FacilityID,
      LeakName: item.LeakingName,
      LeakingRetired: item.LeakingRetired
    }));
  }

  processData(){
    this.leakData.forEach((leak: any) => {
        if(leak.LeakingRetired == 'True'){
          leak.status = 'Inactive';
            leak.buttonName = 'Unretire'
        } else {
            leak.status = 'Active';
            leak.buttonName = 'Retire'

          } 
    });
    this.isLoading = false;

  } 
  retire(row: any) {
    if (confirm(`Are you sure you want to update a record?`)) {

    let payload = {
      "region": "Leaking",
      "recID": row.RecID,
      "retired": row.LeakingRetired == 'True' ? false : true
    }

    this.adminService.RETIREUSERINTERACTION(payload).subscribe({  
      next: (message: any) => {
        this.messageService.showSuccess(message.message );
        this.setLeakData();
      }
    })
  } 
  }

  exportToExcel(){
    this.commonService.exportToExcel(this.exportData, 'TLRAdmin-Leaks.xlsx', 'TLRAdmin-LeakTypes');
    this.messageService.showSuccess("file downloaded successfully" );
  }
  changeNav(){
    this.SaveSuccess = false;
    this.errorData = false;
  }
  addLeak(){
    this.errorData = false;
    this.SaveSuccess = false;
    if(this.newLeakName == ''){
      this.errorData = true;
      this.messageService.showError("Please fill all the fields" );

      return;
    }
    let payload = {
      region: "Leaking",
      data: {
        LeakingName: this.newLeakName,
        FacilityID: this.commonService.getCurrentFacilityId(),
      }
    }
    this.adminService.submitUserInteraction(payload).subscribe({
      next: (message: string) => {
        this.SaveSuccess = true;
        this.messageService.showSuccess(message);
        this.newLeakName = '';
        this.setLeakData();
      }
    })
  }
}
